import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {WHITE} from 'ui-library/Colors';

export interface SignupModalProps {
  children?: JSX.Element;
}

function SignupModal(props: SignupModalProps): JSX.Element {
  return <div className={css(styles.modal)}>{props.children != null && props.children}</div>;
}

export interface SignupScreenProps {
  children?: JSX.Element;
}

export default function SignupScreen(props: SignupScreenProps): JSX.Element {
  return (
    <div className={classNames('container u-flex-grow u-justify-content-center', css(styles.page))}>
      <SignupModal>{props.children}</SignupModal>
    </div>
  );
}

const styles = StyleSheet.create({
  page: {
    paddingTop: '107px',
  },
  modal: {
    borderTop: '7px solid #2A5CF9',
    borderRadius: '0px 0px 4px 4px',
    boxShadow: '0px 2px 6px rgba(162, 185, 190, 0.7)',
    height: '476px',
    width: '775px',
    backgroundColor: WHITE,
  },
});
